import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentQueueComponent } from './payment-queue.component';
import { CardPaymentQueueModule } from './card-payment-queue/card-payment-queue.module';
import { SlideModule } from '@app/core/components/slide/slide.module';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { EmptyComponentModule } from '../empty-component/empty-component.module';

@NgModule({
    declarations: [PaymentQueueComponent],
    exports: [PaymentQueueComponent],
    imports: [CommonModule, CardPaymentQueueModule, SlideModule, MatProgressSpinnerModule, EmptyComponentModule]
})
export class PaymentQueueModule {}
